import styled from "styled-components";

export const Container = styled.label``;

export const HiddenInput = styled.input`
  display: none;
`;
